import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import SiteHeader from '@/components/landing/site-header'
import HeroSection from '@/components/landing/hero-section'
import HowItWorksSection from '@/components/landing/how-it-works-section'
import TeamsSection from '@/components/landing/teams-section'
import ExampleSection from '@/components/landing/example-section'
import BenefitsSection from '@/components/landing/benefits-section'
import FaqSection from '@/components/landing/faq-section'
import DemoSection from '@/components/landing/demo-section'
import SiteFooter from '@/components/landing/site-footer'

const Home: FC = (): ReactNode => {
    return (
        <>
            <Seo />
            <SiteHeader />

            <Layout>
                <HeroSection />
                <HowItWorksSection />
                <TeamsSection />
                <ExampleSection />
                <BenefitsSection />
                <FaqSection />
                <DemoSection />
            </Layout>

            <SiteFooter />
        </>
    )
}

export default Home
